import { formatRelative } from '@/utils/formatDate';
import type { NotificationDto } from '@/features/notifications/notifications.api';
import { clsx } from 'clsx';

export function NotificationItem({ notification, onRead }: { notification: NotificationDto; onRead: (id: number) => void }) {
  return (
    <li
      className={clsx('notification-item', !notification.isRead && 'notification-item--unread')}
      onClick={() => !notification.isRead && onRead(notification.notificationId)}
    >
      <p className="notification-item__title">{notification.title}</p>
      <p className="notification-item__message">{notification.message}</p>
      <time>{formatRelative(notification.createdAt)}</time>
    </li>
  );
}
